import { RequestService } from "../../../../../common/services/RequestService";
import { GET_FILTER_REQUESTS } from "../constants";
import {
  adjustRequestData,
  dataAdjustmentFiltersRequest
} from "./adjustRequestData";
export const getFilterRequestRequest = async (profileId, filters = {}) => {
  const response = await RequestService.get(GET_FILTER_REQUESTS + profileId, {
    params: dataAdjustmentFiltersRequest(filters)
  });
  return {
    pagination: {
      ...response.data.meta
    },
    data:
      response.data.data &&
      response.data.data.map(request => adjustRequestData(request))
  };
};
